import(/* webpackMode: "eager" */ "/home/ubuntu/download/69a019b7174f270014fe0e90/businesscard/src/app/not-found.tsx");
